import React from 'react';
import Checkbox from '../Checkbox';
import Label from '../Label';
import Flex from '../../Flex';
import FieldError from '../FieldError';
import FieldWrapper from '../FieldWrapper';

// eslint-disable-next-line
const FormikCheckboxField = ({ field, form, label, children, hidden, ...other }) => {
  return (
    <FieldWrapper hidden={hidden}>
      <Flex alignItems="center">
        <Checkbox
          {...field}
          {...other}
          checked={field.value}
          hasError={(field.name in form.touched) && (field.name in form.errors)}
          type="checkbox"
          style={{ marginRight: '10px' }}
        />
        {label && <Label isInline>{label}</Label>}
        {children}
      </Flex>
      {form.errors[field.name] && form.touched[field.name]
        && <FieldError style={{ marginTop: '5px' }}>{form.errors[field.name]}</FieldError>}
    </FieldWrapper>

  );
};

export default FormikCheckboxField;
